import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "gatsby-plugin-intl";

const Common_feature_content = ({featureTitle, featureDescription, featureScheme, titleColor, contextColor, dividerColor}) => {

  let customTitleColor = titleColor;
  let customContextColor = contextColor;
  let customDividerColor = dividerColor;

    return (
      <div className="flex flex-col p-4 justify-items-center text-center max-w-6xl mx-auto">
          <div>
            <h1 className={"my-4 text-3xl md:text-5xl font-bold leading-tight " + customTitleColor}>
              <FormattedMessage id={featureTitle} />
            </h1>
          </div>
          <div className="w-full mb-0 md:mb-4">
            <div className={"h-1 mx-auto w-48 md:w-64 my-0 py-0 rounded-t " + customDividerColor} />
          </div>
          <div>
            <h4 className={"my-2 md:text-xl pt-0 md:pt-2 " + customContextColor}>
              <FormattedMessage id={featureDescription} defaultMessage="description1" />
            </h4>
          </div>
          <div className="w-full md:w-4/5 place-self-center pt-4">
            {featureScheme}
          </div>
        </div>
    );
}

Common_feature_content.propTypes = {
    featureTitle: PropTypes.string,
    featureDescription: PropTypes.string,
    featureScheme: PropTypes.string,
    titleColor: PropTypes.string,
    contextColor: PropTypes.string,
    dividerColor: PropTypes.string
};
    
Common_feature_content.defaultProps = {
  titleColor: 'text-black',
  contextColor: 'text-gray-600',
  dividerColor: 'gradient'
}

export default Common_feature_content;